import React from 'react'
import Dashboard from '../desktopViews/Dashboard/index'
import Meets from '../desktopViews/Meets/index'

import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";


const Router = () => {



    const router = createBrowserRouter([
        {
            path: "/",
            element: <Dashboard />,
        },
        {
            path: "/Meet/:meetId",
            element: <Meets />,
        }
    ]);
    return (
        <div>
            <RouterProvider router={router} />
        </div>
    )
}

export default Router

